<template>
    <el-row >
        <!-- <el-col :span="16">
            <web-login></web-login>
        </el-col>
        <el-col :span="8">
            
        </el-col> -->

        <el-col :span="24">
            <div style="background-image:url(./static/images/bg1.jpg);height:305px;padding:12px 20px;box-sizing:border-box;">
                <el-row :gutter="20">
                    <el-col :span="5">
                        <column-index :list="{type_name:'校园公告',type_id:'port03'}">
                            <list-simple :list="bbsList" :date="false">
                            </list-simple>
                        </column-index>
                    </el-col>
                    <el-col :span="1"> &nbsp; </el-col>
                     <el-col :span="18">
                         <el-row :gutter="12">
                             <el-col :span="12">
                                 <slider style="margin:20px 20px 0 20px"  :interval="7000" :list='banner1' type="banner" itemHeight="245px">
                                    <template slot-scope="data">
                                        <div class="slider-index">
                                            <router-link target="_blank" :to="'/article/'+data.row.article_id">
                                                <div class="img" :style="'background-image:url('+data.row.first_img+')'" style="height:245px"> 
                                                    <div class="title am-text-truncate">
                                                    <el-tag size="mini" v-if="data.row.port_new=='1'">新</el-tag>
                                                    <el-tag size="mini" v-if="data.row.port_top=='1'" type="danger">顶</el-tag>
                                                        <router-link target="_blank" :to="'/article/'+data.row.article_id">{{data.row.title}}</router-link>
                                                    </div>
                                                </div>
                                                
                                            </router-link>
                                        </div>
                                    </template>
                                </slider>
                             </el-col>

                             <el-col :span="12">
                                 <column-index :list="{type_name:'校园动态',type_id:'port02'}">
                                    <list-simple :list="newsList"  >
                                    </list-simple>
                                </column-index>
                             </el-col>
                         </el-row>
                    </el-col>
                </el-row>

                



            </div>
        </el-col>

        

        <el-col :span="6">
                <div style="background-image:url(./static/images/bg2.png);height:845px;padding:12px 20px;box-sizing:border-box;">
                        <div class="principal"  >
                            <slider :interval="7000" :list='xzList' type="banner" itemHeight="250px">
                                    <template slot-scope="data">
                                        <div class="img" :style="'background-image:url('+data.row.first_img+')'" style="height:250px"> 
                                        </div>
                                    </template>
                                </slider>
                        </div>

                        <div class="link-box">
                            <ul>
                                <li v-for="(item,index) in link" :key="index">
                                    <a :href="item.sub_title" target="_blank"><img :src="item.first_img" alt=""> {{item.title}}</a>
                                </li>
                            </ul>
                              <web-search></web-search>
                        </div>

                </div>
        </el-col>

        <el-col :span="18">
                <div style="background-image:url(./static/images/bg3.png);height:265px;width:874px;float:right;margin-top:40px;padding:20px 20px;box-sizing:border-box;">
                    <el-row :gutter="12">
                        <el-col :span="15">
                            <tabs>
                                <tabs-pane v-for="(item,index) in tabsList " :key="index" :link="item.type_id" :label="item.type_name" :name='index'>
                                    <list-simple :list="item.dt" >
                                    </list-simple>
                                </tabs-pane>
                            </tabs>
                        </el-col>
                        <el-col :span="9">
                            <slider style="margin-right:12px;margin-top:12px"  :interval="7000" :list='siList' type="banner" itemHeight="210px">
                                    <template slot-scope="data">
                                        <div class="slider-index">
                                            <router-link target="_blank" :to="'/article/'+data.row.article_id">
                                                <div class="img" :style="'background-image:url('+data.row.first_img+')'" style="height:210px">
                                                     <div class="title am-text-truncate">
                                                    <el-tag size="mini" v-if="data.row.port_new=='1'">新</el-tag>
                                                    <el-tag size="mini" v-if="data.row.port_top=='1'" type="danger">顶</el-tag>
                                                    <router-link target="_blank" :to="'/article/'+data.row.article_id">{{data.row.title}}</router-link>
                                                </div>
                                                </div>
                                               
                                            </router-link>
                                        </div>
                                    </template>
                                </slider>
                        </el-col>
                    </el-row>
                </div>



                <div style="background-image:url(./static/images/bg4.png);background-repeat:no-repeat;background-position:left center;height:244px;width:874px;float:right;margin-top:25px;padding:20px 20px 20px 10px;box-sizing:border-box;">
                    <el-row  >
                        <el-col :span="24">
                           <column-index2 :list="{type_name:'喜报之窗',type_id:'port07'}">

                    <slider :interval="4000" :list='xbList' type="slider" itemHeight="165px"  itemWidth="250px" style="margin-top:12px" >
                        <template slot-scope="data">
                            <div class="slider-roll" style="padding:0 6px;">
                                <div class="content">
                                    <router-link :to="'/article/'+data.row.article_id" target="_blank">
                                    <div class="img" :style="'height:165px;background-image:url('+(data.row.first_img==''?'static/img/nopic.gif':data.row.first_img)+')'">
                                    </div>
                                    </router-link>
                                </div>
                            </div>
                        </template>
                    </slider>
                                    <!-- <list-simple :list="xbList"  >
                                    </list-simple> -->
                                </column-index2>
                        </el-col>
                         <!-- <el-col :span="1">
                             &nbsp;
                         </el-col> -->

                        <!-- <el-col :span="15">
                           <column-index2 :list="{type_name:'红领巾之家',type_id:'port08'}">
                                    <el-row :gutter="12">
                                        <el-col :span="10">
                                            <slider  style="margin-top:12px"  :interval="7000" :list='banner3' type="banner" itemHeight="168px">
                                    <template slot-scope="data">
                                        <div class="slider-index">
                                            <router-link target="_blank" :to="'/article/'+data.row.article_id">
                                                <div class="img" :style="'background-image:url('+data.row.first_img+')'" style="height:168px">
                                                     <div class="title am-text-truncate">
                                                    <el-tag size="mini" v-if="data.row.port_new=='1'">新</el-tag>
                                                    <el-tag size="mini" v-if="data.row.port_top=='1'" type="danger">顶</el-tag>
                                                    <router-link target="_blank" :to="'/article/'+data.row.article_id">{{data.row.title}}</router-link>
                                                </div>
                                                </div>
                                               
                                            </router-link>
                                        </div>
                                    </template>
                                </slider>
                                            
                                        </el-col>
                                        <el-col :span="14">
                                            <list-simple :list="hljList"  >
                                    </list-simple>
                                        </el-col>
                                    </el-row>
                           
                                    
                                </column-index2>
                        </el-col> -->

                    </el-row>
                </div>



                <div style="background-image:url(./static/images/bg6.png);height:256px;width:877px;float:right;margin-top:15px;padding:20px 20px;box-sizing:border-box;">
                    <el-row :gutter="30">
                        <el-col :span="8" v-for="(item,index) in tabsList2" :key="index">
                            <column-index :list="item">
                                    <list-simple :list="item.dt"  >
                                    </list-simple>
                                </column-index>
                        </el-col>
                    </el-row>
                </div>


               
        </el-col>


        <el-col :span="24">
            <div style=" background-image:url(./static/images/bg7.png);height:262px; margin-top:16px;padding:20px 20px 20px 106px;box-sizing:border-box;">
            <slider :interval="4000" :list='student' type="slider" itemHeight="220px"  itemWidth="250px"  >
                        <template slot-scope="data">
                            <div class="slider-roll">
                                <div class="content">
                                    <router-link :to="'/article/'+data.row.article_id" target="_blank">
                                    <div class="img" :style="'height:250px;background-image:url('+(data.row.first_img==''?'static/img/nopic.gif':data.row.first_img)+')'">
                                    </div>
                                    </router-link>
                                </div>
                            </div>
                        </template>
                    </slider>
            </div>
        </el-col>


            <el-col :span="24"><web-links></web-links></el-col>

        


        


    </el-row>
</template>

<script>
import {Tabs,TabsPane} from '@/components/tabs'
import WebSearch from '@/components/basic/WebSearch'

import WebLinks from '@/components/basic/WebLinks'
import ListSimple from '@/components/list/ListSimple'
     import ColumnIndex from '@/components/column/ColumnIndex'
      import ColumnIndex2 from '@/components/column/ColumnIndex2'
    import WebLogin from '@/components/basic/WebLogin'
    import slider from '@/components/slider'
    import {
        webInfo
    } from '@/api/base'
    export default {
        components: {
            slider,WebSearch,ColumnIndex,ColumnIndex2,Tabs,TabsPane,
            WebLogin,WebLinks,
            ListSimple,
        },
        data() {
            return {
                schoolName: '',
                newsList: [],
                tabsList: [],
                 tabsList2: [],
                 bbsList:[],
xbList:[],hljList:[],
                 banner1:[],
                 banner2:[],
                  banner3:[],
                   banner4:[],
xzList:[],link:[],siList:[],
                   student:[],
            }
        },
        created() {
            webInfo().then(result => {
                this.schoolName = result.school_name;
                document.title = this.schoolName
            })

            this.getList({
                typeId: 'port3005',//
                rowNum: '5',
                 imgFlg:1,
            }).then(result => {
                this.xzList =result
            })


            this.getColumn({
                typeId: 'port0401,port0402,port0403,port0404,port44',
                rowNum: '7,7,7,7,7',
            }).then(result => {
                this.tabsList = result
            })

            this.getColumn({
                typeId: 'port0504,port0502,port0503',
                rowNum: '7,7,7',
            }).then(result => {
                this.tabsList2 = result
            })

              this.getList({
                typeId: 'port02',
                rowNum: '10',
                imgFlg:1,
            }).then(result => {
                this.banner1 = result
            })

 this.getList({
                typeId: 'port04',
                rowNum: '10',
                imgFlg:1,
            }).then(result => {
                this.siList = result
            })

            

            this.getList({
                typeId: 'port32 ',
                rowNum: '7',
                imgFlg:1,
            }).then(result => {
                this.link = result.reverse()
            })



            


            this.getList({
                typeId: 'port04',
                rowNum: '10',
                imgFlg:1,
            }).then(result => {
                this.banner2 = result
            })


            this.getList({
                typeId: 'port02',
                rowNum: '8',
            }).then(result => {
                this.newsList = result
            })
            
            this.getList({
                typeId: 'port03',
                rowNum: '9',
            }).then(result => {
                this.bbsList = result
            })
            
            this.getList({
                typeId: 'port07',
                rowNum: '30', imgFlg:1,
            }).then(result => {
                this.xbList = result
            })
            this.getList({
                typeId: 'port08',
                rowNum: '7',
            }).then(result => {
                this.hljList = result
            })
             this.getList({
                typeId: 'port08',
                rowNum: '7',
                 imgFlg:1,
            }).then(result => {
                this.banner3 = result
            })

            this.getList({
                typeId: 'port06',
                rowNum: '20',
                 imgFlg:1,
            }).then(result => {
                this.student = result
            })

            
            




        }
    }
</script>


<style lang="scss">
.link-box{
    padding-left: 12px;
    margin-top: 50px;
    li{
        margin-bottom: 12px;
  border-radius: 20px;
  background-color: rgb(226, 246, 254);
  width: 225px;
  height: 46px;
  line-height: 46px;
  padding-left: 50px;
  box-sizing: border-box;
  color: #125871;
  font-size: 14px;
  &:hover{
      text-decoration: underline;
  }
img{
   vertical-align: middle;
   margin-right: 12px;
}
    }
}
.principal{
    height: 315px;
    margin-top: 60px;
    margin-left: 30px;
    margin-right:30px;
    padding: 0px;
    margin-bottom: 30px;
    
    // .img{
    //     height: 80px;
    //     // margin-top: 8px;
    // }
    // .context{
    //     font-size: 14px;
    //     &:hover{
    //         color: $primary;
    //         text-decoration: underline;
    //     }
    //     color: gray;
    //     margin-top: 8px;
    // }
}
.slider-roll{
    margin-right: 8px;
    .content{
        .img{
              position: relative;
            .title {
                position: absolute;
                bottom: 0px;
                width: 100%;
                color: white !important;
                 font-size:13px;
                a:hover {
                    color: white !important;
                }

                padding: 4px 6px;
                background-color:rgba(0, 0, 0, .5)
            }
        }
    }

}
.slider-index {
        .img {
            position: relative;

            .title {
                position: absolute;
                bottom: 0px;
                width: 100%;
                color: white !important;
    font-size:13px;
                a:hover {
                    color: white !important;
                }

                padding: 4px 6px;
                background-color:rgba(0, 0, 0, .5)
            }
        }
    }
</style>
